//@ts-nocheck
import { useQuery } from 'react-query';
import qs from 'qs';

import { axios } from 'lib/axios';

const defaultQueryParams = {
  page: 0,
  limit: 10,
  queryKey: ['invoices'],
  queryOptions: {},
  search: '',
};

const getAllInvoices = async (queryStringParams) => {
  const queryString = qs.stringify({ ...queryStringParams });

  const {
    data: { data: invoices, total },
  } = await axios.get(`/api/invoices?${queryString}`);
  return { invoices, total };
};

export const useInvoices = (queryParams = {}) => {
  const { queryKey, queryOptions, page, limit, search } = {
    ...defaultQueryParams,
    ...queryParams,
  };

  const queryStringParams = {
    limit,
    offset: page * limit,
    search,
  };

  return useQuery([...queryKey, page, limit, search], () => getAllInvoices(queryStringParams), {
    select: ({ invoices, total }) => ({ invoices, total }),
    initialData: {
      invoices: [],
      total: 0,
    },
    ...queryOptions,
  });
};
